import React from "react";
import { Button } from "react-bootstrap";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import { Link, NavLink } from "react-router-dom";
import DoltLabsDailyToolsLogo from "../assets/img/doltlabs-daily-tools-logo-w512.svg"

function Header() {
  return (
    <Navbar expand="lg" className="bg-body-tertiary sticky-top" data-bs-theme="dark">
      <Container fluid>
        <Navbar.Brand href="/">
          <img src={DoltLabsDailyToolsLogo} width={128} alt="" />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            <Nav.Link as={NavLink} to="/">
              Home
            </Nav.Link>
            <Nav.Link as={NavLink} to="/tools">
              Tools
            </Nav.Link>
            <Nav.Link as={NavLink} to="/about">
              About
            </Nav.Link>
            <Nav.Link as={NavLink} to="/contact">
              Contact
            </Nav.Link>
          </Nav>
          <Link className="btn btn-sm btn-outline-light" to="/tools">
            Try It Now
          </Link>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default Header;
